module.exports = __webpack_public_path__ + "assets/img/status-attention.450b0158.svg";